import React from 'react';
import { Users, Briefcase, Clock, Award } from 'lucide-react';
export function Benefits() {
  return <section className="py-16 bg-white" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-17">
            Why Choose CateringCareers?
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-18">
            We connect talented professionals with the best opportunities in the
            catering industry
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-19">
          <div className="bg-amber-50 p-8 rounded-lg" data-id="element-20">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-21">
              For Job Seekers
            </h3>
            <ul className="space-y-6" data-id="element-22">
              <li className="flex" data-id="element-23">
                <Users className="w-6 h-6 text-amber-600 mr-4 flex-shrink-0" data-id="element-24" />
                <div data-id="element-25">
                  <h4 className="text-lg font-semibold text-gray-900" data-id="element-26">
                    Access to Top Employers
                  </h4>
                  <p className="text-gray-600 mt-1" data-id="element-27">
                    Connect with prestigious restaurants, hotels, and catering
                    companies.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-28">
                <Briefcase className="w-6 h-6 text-amber-600 mr-4 flex-shrink-0" data-id="element-29" />
                <div data-id="element-30">
                  <h4 className="text-lg font-semibold text-gray-900" data-id="element-31">
                    Diverse Job Opportunities
                  </h4>
                  <p className="text-gray-600 mt-1" data-id="element-32">
                    Find positions ranging from entry-level to executive roles.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-33">
                <Clock className="w-6 h-6 text-amber-600 mr-4 flex-shrink-0" data-id="element-34" />
                <div data-id="element-35">
                  <h4 className="text-lg font-semibold text-gray-900" data-id="element-36">
                    Flexible Options
                  </h4>
                  <p className="text-gray-600 mt-1" data-id="element-37">
                    Discover full-time, part-time, seasonal, and temporary
                    positions.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-38">
                <Award className="w-6 h-6 text-amber-600 mr-4 flex-shrink-0" data-id="element-39" />
                <div data-id="element-40">
                  <h4 className="text-lg font-semibold text-gray-900" data-id="element-41">
                    Career Advancement
                  </h4>
                  <p className="text-gray-600 mt-1" data-id="element-42">
                    Resources to help you grow and develop your culinary career.
                  </p>
                </div>
              </li>
            </ul>
            <div className="mt-8" data-id="element-43">
              <a href="#" className="inline-block bg-amber-600 text-white px-6 py-3 rounded-md hover:bg-amber-700 transition font-medium" data-id="element-44">
                Create Job Seeker Profile
              </a>
            </div>
          </div>
          <div className="bg-gray-50 p-8 rounded-lg" data-id="element-45">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-46">
              For Employers
            </h3>
            <ul className="space-y-6" data-id="element-47">
              <li className="flex" data-id="element-48">
                <Users className="w-6 h-6 text-amber-600 mr-4 flex-shrink-0" data-id="element-49" />
                <div data-id="element-50">
                  <h4 className="text-lg font-semibold text-gray-900" data-id="element-51">
                    Talent Pool
                  </h4>
                  <p className="text-gray-600 mt-1" data-id="element-52">
                    Access a diverse pool of qualified catering professionals.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-53">
                <Briefcase className="w-6 h-6 text-amber-600 mr-4 flex-shrink-0" data-id="element-54" />
                <div data-id="element-55">
                  <h4 className="text-lg font-semibold text-gray-900" data-id="element-56">
                    Streamlined Hiring
                  </h4>
                  <p className="text-gray-600 mt-1" data-id="element-57">
                    Efficient tools to post jobs, screen applicants, and manage
                    hiring.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-58">
                <Clock className="w-6 h-6 text-amber-600 mr-4 flex-shrink-0" data-id="element-59" />
                <div data-id="element-60">
                  <h4 className="text-lg font-semibold text-gray-900" data-id="element-61">
                    Time-Saving
                  </h4>
                  <p className="text-gray-600 mt-1" data-id="element-62">
                    Find the right candidates quickly with our matching
                    algorithm.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-63">
                <Award className="w-6 h-6 text-amber-600 mr-4 flex-shrink-0" data-id="element-64" />
                <div data-id="element-65">
                  <h4 className="text-lg font-semibold text-gray-900" data-id="element-66">
                    Employer Branding
                  </h4>
                  <p className="text-gray-600 mt-1" data-id="element-67">
                    Showcase your company culture to attract the best talent.
                  </p>
                </div>
              </li>
            </ul>
            <div className="mt-8" data-id="element-68">
              <a href="#" className="inline-block bg-gray-800 text-white px-6 py-3 rounded-md hover:bg-gray-900 transition font-medium" data-id="element-69">
                Post a Job
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}